import React, { useEffect, useState } from 'react';
import { useCollection, useEvents, useGeoObjectCoords, useGeoObjectOptions, useGeoObjectProperties } from '../../hooks';
var Circle = function (_a) {
    var center = _a.center, radius = _a.radius, properties = _a.properties, options = _a.options, events = _a.events;
    var geoObject = useState(function () {
        return new ymaps.Circle([center, radius], properties, options);
    })[0];
    useEffect(function () {
        if (geoObject) {
            geoObject.geometry.setRadius(radius);
        }
    }, [geoObject, radius]);
    useCollection(geoObject);
    useEvents(geoObject, events);
    useGeoObjectCoords(geoObject, center);
    useGeoObjectOptions(geoObject, options);
    useGeoObjectProperties(geoObject, properties);
    return null;
};
export default React.memo(Circle);
